// @owners { team: patients }
import { useEffect } from 'react';
import { getCompanyFullName, getCompanyName } from '~shared/config/getCompanyName';
import { faviconURLByDomain, updateFaviconLinks } from '~web/hooks/favicons';

const addMetaTags = (appName: string) => {
  const appNameMetaTag = document.createElement('meta');
  appNameMetaTag.setAttribute('name', 'application-name');
  appNameMetaTag.setAttribute('content', appName);
  document.head.appendChild(appNameMetaTag);

  const mobileWebAppTitleMetaTag = document.createElement('meta');
  mobileWebAppTitleMetaTag.setAttribute('name', 'apple-mobile-web-app-title');
  mobileWebAppTitleMetaTag.setAttribute('content', appName);
  document.head.appendChild(mobileWebAppTitleMetaTag);
};

/**
 * Sets the favicon and title for the browser tab. Post-rebrand everything is FuzeRx, except the
 * standalone patient-support-program page which keeps its own identity.
 */
export const useBrowserTab = () => {
  const currentHostName = window.location.hostname;

  useEffect(() => {
    if (currentHostName.includes('patientrxauth')) {
      updateFaviconLinks({ faviconURL: faviconURLByDomain['patientrxauth'] });
      document.title = 'Patient support program';
      return;
    }

    updateFaviconLinks({ faviconURL: faviconURLByDomain['fuzerx'] });
    // TODO: now that brand needs no runtime resolution, this can move to apps/web/src/template.ejs
    document.title = `${getCompanyFullName()} | Get your prescriptions delivered`;
    addMetaTags(getCompanyName());
  }, [currentHostName]);
};
